import EmployeePage from "../pages/Employee";
import AddEmployeePage from "../pages/Employee/AddEmployeePage";
import EmployeeProfilePage from "../pages/Employee/EmployeeProfilePage";
import ImportEmployeePage from "../pages/Employee/ImportEmployeePage";
import DesignationMasterPage from "../pages/DesignationMaster";
import ProjectPage from "../pages/Project";
import AddProjectPage from "../pages/Project/AddProjectPage";
import ImportProjectPage from "../pages/Project/ImportProjectPage";
import ChangeRequestsPage from "../pages/ChangeRequests";
import PurchaseApprovalsPage from "../pages/PurchaseApprovals";
import LeaveRequestsPage from "../pages/LeaveRequests";
import PTSNavigationRoutes from "./navigationRoutes";
import DashboardPage from "../pages/Dashboard";
import ExecutiveDashboardPage from "../pages/ExecutiveDashboard";
import Auth from "../pages/Auth/AdminLogin";
import SettingsListPage from "../pages/SettingsListPage";
import SettingsFormPage from "../pages/SettingsListPage/SettingsPage";
import TodaysHoursPage from "../pages/TodaysHours";
import AttendancePage from "../pages/Attendance";
import MyAttendanceReportPage from "../pages/MyAttendanceReport";
import EmployeeCheckinPage from "../pages/EmployeeCheckin";
import SprintPage from "../pages/Sprint";
import SprintTaskAllocationPage from "../pages/SprintTaskAllocation";
import TaskPage from "../pages/Task";
import ServiceDeskTasksPage from "../pages/ServiceDeskTasks";
import ProjectTemplatesPage from "../pages/ProjectTemplates";
import EmployeeRatesPage from "../pages/EmployeeRates";
import EmployeeDashboardPage from "../pages/EmployeeDashboard";
import SpentHoursPage from "../pages/SpentHours";
import DailySpentHoursPage from "../pages/DailySpentHours";
import RemainingTimeReportPage from "../pages/RemainingTimeReport";
import ProjectSummaryPage from "../pages/ProjectSummary";
import BillingSummaryPage from "../pages/BillingSummary";
import ExpenseSummaryPage from "../pages/ExpenseSummary";
import ExpenseDashboardPage from "../pages/ExpenseSummary/Dashboard";
import BillingInvoicePage from "../pages/Billing/BillingInvoice";
import InvoiceRemindersPage from "../pages/Billing/BillingInvoice/InvoiceRemindersPage";
import ProjectSettingPage from "../pages/Billing/ProjectSetting";
import NotificationsPage from "../pages/Notifications";
import ResourceAllocationPage from "../pages/ResourceAllocation";
import RolesPermissionsPage from "../pages/RolesPermissions";
import RolePermissionManager from "../pages/RolesPermissions/RolePermissionManager";
import LeaveApplicationPage from "../pages/LeaveApplication";
import HolidayListPage from "../pages/HolidayList";
import AddHolidayPage from "../pages/HolidayList/AddHolidayPage";
import ImportHolidayPage from "../pages/HolidayList/ImportHolidayPage";
import ChatPage from "../pages/Chat";

const PTSRoutes = {
  employee: {
    path: PTSNavigationRoutes.EMPLOYEE,
    component: EmployeePage,
    name: "Employee",
  },
  designationMaster: {
    path: PTSNavigationRoutes.DESIGNATION_MASTER,
    component: DesignationMasterPage,
    name: "Designation Master",
  },
  dashboard: {
    path: PTSNavigationRoutes.DASHBOARD,
    component: DashboardPage,
    name: "Dashboard",
  },
  executiveDashboard: {
    path: PTSNavigationRoutes.EXECUTIVE_DASHBOARD,
    component: ExecutiveDashboardPage,
    name: "Executive Dashboard",
  },

  adminLoginPage: {
    path: PTSNavigationRoutes.ADMIN_LOGIN_PAGE,
    component: Auth,
    name: "Admin Login Page",
  },

  settingslist: {
    path: PTSNavigationRoutes.SETTINGS_LIST,
    component: SettingsListPage,
    name: "Settings List",
  },
  createsettings: {
    path: PTSNavigationRoutes.CREATE_SETTINGS,
    component: SettingsFormPage,
    name: "Create Settings",
  },
  todaysHours: {
    path: PTSNavigationRoutes.TODAYS_HOURS,
    component: TodaysHoursPage,
    name: "Today's Hours",
  },
  attendance: {
    path: PTSNavigationRoutes.ATTENDANCE,
    component: AttendancePage,
    name: "Attendance",
  },
  myAttendanceReport: {
    path: PTSNavigationRoutes.MY_ATTENDANCE_REPORT,
    component: MyAttendanceReportPage,
    name: "My Attendance Report",
  },
  employeeCheckin: {
    path: PTSNavigationRoutes.EMPLOYEE_CHECKIN,
    component: EmployeeCheckinPage,
    name: "Employee Check-In",
  },
  employeeProfile: {
    path: PTSNavigationRoutes.EMPLOYEE_PROFILE,
    component: EmployeeProfilePage,
    name: "My Profile",
  },
  createEmployee: {
    path: PTSNavigationRoutes.CREATE_EMPLOYEE,
    component: AddEmployeePage,
    name: "Create Employee",
  },
  editEmployee: {
    path: PTSNavigationRoutes.EDIT_EMPLOYEE_ROUTE,
    component: AddEmployeePage,
    name: "Edit Employee",
  },
  importEmployee: {
    path: PTSNavigationRoutes.IMPORT_EMPLOYEE,
    component: ImportEmployeePage,
    name: "Import Employee",
  },
  project: {
    path: PTSNavigationRoutes.PROJECTS,
    component: ProjectPage,
    name: "Project",
  },
  changeRequests: {
    path: PTSNavigationRoutes.CHANGE_REQUESTS,
    component: ChangeRequestsPage,
    name: "Change Requests",
  },
  purchaseApprovals: {
    path: PTSNavigationRoutes.PURCHASE_APPROVALS,
    component: PurchaseApprovalsPage,
    name: "Purchase Approval",
  },
  leaveRequests: {
    path: PTSNavigationRoutes.LEAVE_REQUESTS,
    component: LeaveRequestsPage,
    name: "Leave Request",
  },
  createProject: {
    path: PTSNavigationRoutes.CREATE_PROJECT,
    component: AddProjectPage,
    name: "Create Project",
  },
  editProject: {
    path: PTSNavigationRoutes.EDIT_PROJECT_ROUTE,
    component: AddProjectPage,
    name: "Edit Project",
  },
  importProject: {
    path: PTSNavigationRoutes.IMPORT_PROJECT,
    component: ImportProjectPage,
    name: "Import Project",
  },
  sprint: {
    path: PTSNavigationRoutes.SPRINT,
    component: SprintPage,
    name: "Sprint",
  },
  sprintTaskAllocation: {
    path: PTSNavigationRoutes.SPRINT_TASK_ALLOCATION,
    component: SprintTaskAllocationPage,
    name: "Sprint Task Allocation",
  },
  task: {
    path: PTSNavigationRoutes.TASKS,
    component: TaskPage,
    name: "Task",
  },
  serviceDeskTasks: {
    path: PTSNavigationRoutes.SERVICE_DESK_TASKS,
    component: ServiceDeskTasksPage,
    name: "Service Desk Tasks",
  },
  projectTemplates: {
    path: PTSNavigationRoutes.PROJECT_TEMPLATES,
    component: ProjectTemplatesPage,
    name: "Project Templates",
  },
  employeeRates: {
    path: PTSNavigationRoutes.EMPLOYEE_RATES,
    component: EmployeeRatesPage,
    name: "Employee Rates",
  },
  employeeDashboard: {
    path: PTSNavigationRoutes.EMPLOYEE_DASHBOARD,
    component: EmployeeDashboardPage,
    name: "Employee Dashboard",
  },
  spentHours: {
    path: PTSNavigationRoutes.SPENT_HOURS,
    component: SpentHoursPage,
    name: "Spent Hours",
  },
  dailySpentHours: {
    path: PTSNavigationRoutes.DAILY_SPENT_HOURS,
    component: DailySpentHoursPage,
    name: "Daily Spent Hours",
  },
  remainingTimeReport: {
    path: PTSNavigationRoutes.REMAINING_TIME_REPORT,
    component: RemainingTimeReportPage,
    name: "Remaining Time Report",
  },
  projectSummary: {
    path: PTSNavigationRoutes.PROJECT_SUMMARY,
    component: ProjectSummaryPage,
    name: "Project Summary",
  },
  billingSummary: {
    path: PTSNavigationRoutes.BILLING_SUMMARY,
    component: BillingSummaryPage,
    name: "Billing Summary",
  },
  expenseSummary: {
    path: PTSNavigationRoutes.EXPENSE_SUMMARY,
    component: ExpenseSummaryPage,
    name: "Expense Summary",
  },
  expenseDashboard: {
    path: PTSNavigationRoutes.EXPENSE_DASHBOARD,
    component: ExpenseDashboardPage,
    name: "Expense Dashboard",
  },
  billingInvoice: {
    path: PTSNavigationRoutes.BILLING_INVOICE,
    component: BillingInvoicePage,
    name: "Billing Invoice",
  },
  billingInvoiceReminders: {
    path: PTSNavigationRoutes.BILLING_INVOICE_REMINDERS,
    component: InvoiceRemindersPage,
    name: "Invoice Reminders",
  },
  billingProjectSetting: {
    path: PTSNavigationRoutes.BILLING_PROJECT_SETTING,
    component: ProjectSettingPage,
    name: "Project Setting",
  },
  notifications: {
    path: PTSNavigationRoutes.NOTIFICATIONS,
    component: NotificationsPage,
    name: "Notifications",
  },
  resourceAllocation: {
    path: PTSNavigationRoutes.RESOURCE_ALLOCATION,
    component: ResourceAllocationPage,
    name: "Resource Allocation",
  },
  chat: {
    path: PTSNavigationRoutes.CHAT,
    component: ChatPage,
    name: "Chat",
  },
  rolesPermissions: {
    path: PTSNavigationRoutes.ROLES_LIST,
    component: RolesPermissionsPage,
    name: "Roles & Permissions",
  },
  rolePermissionManager: {
    path: PTSNavigationRoutes.ROLE_PERMISSION_MANAGER,
    component: RolePermissionManager,
    name: "Role Permission Manager",
  },
  leaveApplication: {
    path: PTSNavigationRoutes.LEAVE_APPLICATION,
    component: LeaveApplicationPage,
    name: "Leave Application",
  },
  holidayList: {
    path: PTSNavigationRoutes.HOLIDAY_LIST,
    component: HolidayListPage,
    name: "Holiday List",
  },
  createHoliday: {
    path: PTSNavigationRoutes.CREATE_HOLIDAY,
    component: AddHolidayPage,
    name: "Create Holiday",
  },
  editHoliday: {
    path: PTSNavigationRoutes.EDIT_HOLIDAY_ROUTE,
    component: AddHolidayPage,
    name: "Edit Holiday",
  },
  importHoliday: {
    path: PTSNavigationRoutes.IMPORT_HOLIDAY,
    component: ImportHolidayPage,
    name: "Import Holiday",
  },
};

export default PTSRoutes;
